import React, { useState, useEffect } from "react";
import InteractiveEditorComponent from "./interactiveEditor.component";
import Authentication from "../content-template/authentication";
import Facebook from "../content-template/facebook";
import Gallery from "../content-template/gallery";
import Instagram from "../content-template/instagram";
import Website from "../content-template/website";
import Video from "../content-template/video";
import Tiktok from "../content-template/tiktok";
import Text from "../content-template/text";
import Marketplace from "../content-template/marketplace";
import { connect } from "react-redux";
import { DragDropContext } from "react-beautiful-dnd";
import { reorderComponent } from "../../redux/slice/productPage.slice";
import ComponentActionPanel from "../panel/componentActionPanel";
import { useSelector, useDispatch } from "react-redux";
import Warranty from "../content-template/warranty";
import AdditionalInfo from "../content-template/additionalInfo";
import LoyaltyPoint from "../content-template/loyaltyPoint";
import Survey from "../content-template/survey";
import LuckyDraw from "../content-template/luckyDraw";
import InstantWin from "../content-template/instantWin";
import Co2Footprint from "../content-template/co2Footprint";
import WebVideo from "../content-template/webVideo";
import { getObjectByString } from "lib/helper";
import { fetchPreviewLanguageData } from "app/feature/constants/constants.action";
import AuthorisedClinic from "../content-template/authorisedClinic";
import SearchTerm2 from "../content-template/searchTerm2";
import InstantWinList from "../content-template/instantWinList";
import LuckyDrawList from "../content-template/luckyDrawList";

function InteractiveEditorContainer({
  componentIds,
  reorderComponent,
  previewMode,
  companyLogo,
  components,
  language,
}) {
  const uiSetting = useSelector((state) => state.setting.uiSetting);
  const currentLanguage = language;
  const previewLangData = useSelector(state => state.productPage.previewLanguageData);
  const fallbackData = useSelector(state => state.constant.languages.fallbackData);
  const [isAnyComponentHidden, setIsAnyComponentHidden] = useState(false);
  const dispatch = useDispatch();

  const getPreviewTranslation = (key, values = null) => {
    let translation = getObjectByString(previewLangData, key) ?? getObjectByString(fallbackData, key) ?? key;
    if (translation !== key && values && Object.keys(values).length > 0) {
      Object.keys(values).forEach((k) => {
        translation = translation.replace(`{${k}}`, values[k]);
      });
    }
    return translation;
  };

  useEffect(() => {
    if (currentLanguage) {
      dispatch(fetchPreviewLanguageData({ language: currentLanguage }));
    }
  }, [currentLanguage, dispatch]);

  const populateComponents = () => {
    let isAnyComponentHidden = false;

    let componentsToRender = componentIds.map((id, index) => {
      const type = id.split("-")[0];
      var component = null;

      switch (type) {
        case "authentication":
          component = (
            <Authentication id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />
          );
          break;
        case "additional information":
          component = <AdditionalInfo id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "warranty":
          component = <Warranty id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "facebook":
          component = <Facebook id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "gallery":
          component = <Gallery id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} previewMode={previewMode}/>;
          break;
        case "instagram":
          component = <Instagram id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "website":
          component = <Website id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "video":
          component = <Video id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "tiktok":
          component = <Tiktok id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "text":
          component = <Text id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "marketplace":
          component = <Marketplace id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "loyalty point":
          component = <LoyaltyPoint id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "survey":
          component = <Survey id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "lucky draw":
          component = <LuckyDraw id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "lucky draw list":
          component = <LuckyDrawList id={id} />;
          break;
        case "instant win":
          component = <InstantWin id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "instant win list":
          component = <InstantWinList id={id} />;
          break;
        case "co2 footprint":
          component = <Co2Footprint id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} />;
          break;
        case "authorised clinic":
          component = <AuthorisedClinic id={id} />;
          break;
        case "search term 2":
          component = <SearchTerm2 id={id} />;
          break;
        case "web video":
          component = <WebVideo id={id} currentLanguage={currentLanguage} getTranslation={getPreviewTranslation} previewMode={previewMode} />;
          break;
        default:
          break;
      }

      if (!components[id].isVisible) {
        isAnyComponentHidden = true;
      }

      return (
        <ComponentActionPanel
          id={id}
          key={id}
          draggableIndex={index}
          previewMode={previewMode}
          type={type}
        >
          {component}
        </ComponentActionPanel>
      );
    });

    setIsAnyComponentHidden(isAnyComponentHidden);

    return componentsToRender;
  };

  const handleDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) return;

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    )
      return;

    reorderComponent({
      id: draggableId,
      sourceIndex: source.index,
      destinationIndex: destination.index,
    });
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <InteractiveEditorComponent
        populateComponents={populateComponents}
        previewMode={previewMode}
        companyLogo={companyLogo}
        isAnyComponentHidden={isAnyComponentHidden}
        uiSetting={uiSetting}
      />
    </DragDropContext>
  );
}

const mapStateToProps = (state) => ({
  componentIds: state.productPage.columns.compIds,
  companyLogo: state.account.logoImg,
  components: state.productPage.components,
});

const mapDispatchToProps = (dispatch) => ({
  reorderComponent: (payload) => dispatch(reorderComponent(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InteractiveEditorContainer);
